import { FC, SVGProps } from "react";
import { useMirrorTransform } from "src/i18n/direction";

const MobileBack: FC<SVGProps<SVGSVGElement>> = ({ transform, ...props }) => {
  const mirroredTransform = useMirrorTransform(transform as string | undefined);
  return (
    <svg width="9" height="16" viewBox="0 0 9 16" fill="currentcolor" transform={mirroredTransform} {...props}>
      <path
        d="M0.00021996 7.74978C0.000219968 7.55778 0.0731904 7.36575 0.220191 7.21975L7.22019 0.21975C7.51319 -0.07325 7.98823 -0.07325 8.28123 0.21975C8.57423 0.51275 8.57423 0.987785 8.28123 1.28079L1.81126 7.75076L8.28123 14.2207C8.57423 14.5137 8.57423 14.9888 8.28123 15.2818C7.98823 15.5748 7.51319 15.5748 7.22019 15.2818L0.220191 8.28176C0.0731903 8.13376 0.000219952 7.94178 0.00021996 7.74978Z"
      />
    </svg>
  );
};

export default MobileBack;
